// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { QuoteIocn } from 'components/Common/Icon'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Image from 'next/image'
import React, { FC, useState, useRef, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import ReactPlayer from 'react-player/lazy'
import Slider from 'react-slick'
import { CDN_URL } from 'services/config'

// Images load
// import imageTestimonialAvtar from '../../../../public/assets/images/testimonial-avtar.jpg'
// import imageClient1 from '../../../../public/assets/images/testimonial/client1.jpg'
// import imageClient2 from '../../../../public/assets/images/testimonial/client2.jpg'
// import imageClient3 from '../../../../public/assets/images/testimonial/client3.jpg'
// import imageKiranSingh from '../../../../public/assets/images/testimonial/kiran_singh.jpg'
// import imageMichaelTerranceHoulder from '../../../../public/assets/images/testimonial/Michael_Terrance_Houlder.jpg'
// import imageMikeLanzone from '../../../../public/assets/images/testimonial/Mike_Lanzone.jpg'
// import imageShazMehrKhan from '../../../../public/assets/images/testimonial/shaz-mehr-khan.jpg'
// import imageStephenBelcher from '../../../../public/assets/images/testimonial/stephen_belcher.jpg'
// import imageClient4 from '../../../../public/assets/images/testimonial/v1.jpg'
// import imageClient5 from '../../../../public/assets/images/testimonial/v2.jpg'

const imageTestimonialAvtar = '/assets/images/testimonial-avtar.jpg'
const imageClient1 = '/assets/images/testimonial/client1.jpg'
const imageClient2 = '/assets/images/testimonial/client2.jpg'
const imageClient3 = '/assets/images/testimonial/client3.jpg'
const imageKiranSingh = '/assets/images/testimonial/kiran_singh.jpg'
const imageMichaelTerranceHoulder =
  '/assets/images/testimonial/Michael_Terrance_Houlder.jpg'
const imageMikeLanzone = '/assets/images/testimonial/Mike_Lanzone.jpg'
const imageShazMehrKhan = '/assets/images/testimonial/shaz-mehr-khan.jpg'
const imageStephenBelcher = '/assets/images/testimonial/stephen_belcher.jpg'
const imageClient4 = '/assets/images/testimonial/v1.jpg'
const imageClient5 = '/assets/images/testimonial/v2.jpg'

const VideoPlayer = ({ video, activeVideo, setActiveVideo, posterImg }) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const handleVideoClick = () => {
    const videoElement = videoRef.current
    if (!videoElement) return

    if (isPlaying) {
      videoElement.pause()
      setActiveVideo(0)
    } else {
      videoElement.play()
      setActiveVideo(video.id)
    }
    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    if (videoRef === null) {
      return
    }
    if (video.id === activeVideo) {
      videoRef.current?.play()
      setIsPlaying(true)
    } else {
      videoRef.current?.pause()
      setIsPlaying(false)
    }
  }, [activeVideo])

  return (
    <div
      className={`${
        isPlaying ? 'playing' : 'paused'
      } testimonial-video position-relative mt-lg-4`}
    >
      {isPlaying ? (
        <div className="pause-icon position-absolute">
          <button
            onClick={handleVideoClick}
            className="bg-transparent border-0"
          />
        </div>
      ) : (
        <div className="play-icon position-absolute cursor-pointer">
          <button
            onClick={handleVideoClick}
            className="bg-transparent border-0"
          />
        </div>
      )}

      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        playsInline
        ref={videoRef}
        onClick={handleVideoClick}
        width="100%"
        height="100%"
        poster={posterImg}
      >
        <source src={video.src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

const Testimonials: FC<{ data: any }> = ({ data }) => {
  const [activeVideo, setActiveVideo] = useState(0)

  const videos = [
    {
      id: 1,
      src: `${CDN_URL}/assets/video/video1.mp4`,
      posterImg: `${CDN_URL}/assets/images/testimonial/v1.jpg`,
    },
    {
      id: 2,
      src: `${CDN_URL}/assets/video/video2.mp4`,
      posterImg: `${CDN_URL}/assets/images/testimonial/v2.jpg`,
    },
    {
      id: 3,
      src: `${CDN_URL}/assets/video/client1.mp4`,
      posterImg: `${CDN_URL}/assets/images/testimonial/client1.jpg`,
    },
    {
      id: 4,
      src: `${CDN_URL}/assets/video/client2.mp4`,
      posterImg: `${CDN_URL}/assets/images/testimonial/client2.jpg`,
    },
    {
      id: 5,
      src: `${CDN_URL}/assets/video/client3.mp4`,
      posterImg: `${CDN_URL}/assets/images/testimonial/client3.jpg`,
    },
  ]
  const testimonialsSettings = {
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    // variableWidth: true,
    // adaptiveHeight: false,
    pauseOnHover: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: () => {
      setActiveVideo(0)
    },
  }

  return (
    <section className="testimonials ox-hidden testimonial-video">
      <Container className="position-relative">
        <div className="quote_big_icon position-absolute">
          <QuoteIocn className="quote_icon_grey" />
        </div>
        <Row className="align-items-start">
          <Col lg={5} xl={6} className="testimonial_left" data-aos="fade-right">
            <div className="quote_icon mb-4 pb-3">
              <QuoteIocn className="text-primary" />
            </div>
            <TitleH2 className="mb-4" text={data?.title} />
            {data?.text?.map((t: string, i: React.Key | null | undefined) => {
              return (
                <SubText
                  key={i}
                  className="mb-3 pt-2 text_para_large text-light-third"
                  text={t}
                />
              )
            })}
          </Col>
          <Col lg={7} xl={6} data-aos="fade-left">
            <Slider {...testimonialsSettings}>
              {videos.map((video) => (
                <div className="slide_item" key={video.id}>
                  <VideoPlayer
                    video={video}
                    activeVideo={activeVideo}
                    setActiveVideo={setActiveVideo}
                    posterImg={video.posterImg}
                  />
                </div>
              ))}{' '}
              {/* <div key={1}>
                <div className="image_block">
                  <div className="video_team d-flex align-items-center justify-content-center">
                    <ReactPlayer
                      url={`${CDN_URL}/assets/video/video1.mp4`}
                      className="react-player testimonial-player"
                      controls={false}
                      playing={playingOne}
                      width="100%"
                      height="100%"
                      playIcon={
                        <Button
                          variant="outline-secondary"
                          aria-label="play_btn_client1"
                          className="bg-transp­arent player-action-btn playing--btn"
                        >
                          <Image
                            src="/assets/images/play-button.svg"
                            className=""
                            alt=""
                            height={92}
                            width={92}
                          />
                        </Button>
                      }
                      light={`${CDN_URL}${imageClient4}`}
                      onClick={handlerSetPlayingOne}
                      onPause={pause}
                    />
                    {playingOne ? (
                      <Button
                        className="pauseVbtn player-action-btn"
                        onClick={pause}
                      >
                        <Image
                          src="/assets/images/pause-icon.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        aria-label="play_btn_client1"
                        className="pauseVbtn player-action-btn"
                        onClick={handlerSetPlayingOne}
                      >
                        <Image
                          src="/assets/images/play-button.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div key={2}>
                <div className="image_block video_team_testimonial">
                  <div className="video_team d-flex align-items-center justify-content-center">
                    <ReactPlayer
                      url={`${CDN_URL}/assets/video/client1.mp4`}
                      className="react-player testimonial-player"
                      controls={false}
                      playing={playingTwo}
                      width="100%"
                      height="100%"
                      playIcon={
                        <Button
                          variant="outline-secondary"
                          aria-label="play_btn_client1"
                          className="bg-transp­arent player-action-btn playing--btn"
                        >
                          <Image
                            src="/assets/images/play-button.svg"
                            className=""
                            alt=""
                            height={92}
                            width={92}
                          />
                        </Button>
                      }
                      light={`${CDN_URL}${imageClient1}`}
                      onClick={handlerSetPlayingTwo}
                      onPause={pause}
                    />
                    {playingTwo ? (
                      <Button
                        className="pauseVbtn player-action-btn"
                        onClick={pause}
                      >
                        <Image
                          src="/assets/images/pause-icon.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        aria-label="play_btn_client1"
                        className="pauseVbtn player-action-btn"
                        onClick={handlerSetPlayingTwo}
                      >
                        <Image
                          src="/assets/images/play-button.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div key={3}>
                <div className="image_block video_team_testimonial">
                  <div className="video_team d-flex align-items-center justify-content-center">
                    <ReactPlayer
                      url={`${CDN_URL}/assets/video/client3.mp4`}
                      className="react-player testimonial-player"
                      controls={false}
                      playing={playingThree}
                      width="100%"
                      height="100%"
                      playIcon={
                        <Button
                          variant="outline-secondary"
                          aria-label="play_btn_client1"
                          className="bg-transp­arent player-action-btn playing--btn"
                        >
                          <Image
                            src="/assets/images/play-button.svg"
                            className=""
                            alt=""
                            height={92}
                            width={92}
                          />
                        </Button>
                      }
                      light={`${CDN_URL}${imageClient3}`}
                      onClick={handlerSetPlayingThree}
                      onPause={pause}
                    />
                    {playingThree ? (
                      <Button
                        className="pauseVbtn player-action-btn"
                        onClick={pause}
                      >
                        <Image
                          src="/assets/images/pause-icon.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        aria-label="play_btn_client1"
                        className="pauseVbtn player-action-btn"
                        onClick={handlerSetPlayingThree}
                      >
                        <Image
                          src="/assets/images/play-button.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div key={4}>
                <div className="image_block video_team_testimonial">
                  <div className="video_team d-flex align-items-center justify-content-center">
                    <ReactPlayer
                      url={`${CDN_URL}/assets/video/video2.mp4`}
                      className="react-player testimonial-player"
                      controls={false}
                      playing={playingFour}
                      width="100%"
                      height="100%"
                      playIcon={
                        <Button
                          variant="outline-secondary"
                          aria-label="play_btn_client1"
                          className="bg-transp­arent player-action-btn playing--btn"
                        >
                          <Image
                            src="/assets/images/play-button.svg"
                            className=""
                            alt=""
                            height={92}
                            width={92}
                          />
                        </Button>
                      }
                      light={`${CDN_URL}${imageClient5}`}
                      onClick={handlerSetPlayingFour}
                      onPause={pause}
                    />
                    {playingFour ? (
                      <Button
                        className="pauseVbtn player-action-btn"
                        onClick={pause}
                      >
                        <Image
                          src="/assets/images/pause-icon.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        aria-label="play_btn_client1"
                        className="pauseVbtn player-action-btn"
                        onClick={handlerSetPlayingFour}
                      >
                        <Image
                          src="/assets/images/play-button.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div key={5}>
                <div className="image_block video_team_testimonial">
                  <div className="video_team d-flex align-items-center justify-content-center">
                    <ReactPlayer
                      url={`${CDN_URL}/assets/video/client2.mp4`}
                      className="react-player testimonial-player"
                      controls={false}
                      playing={playingFive}
                      width="100%"
                      height="100%"
                      playIcon={
                        <Button
                          variant="outline-secondary"
                          aria-label="play_btn_client1"
                          className="bg-transp­arent player-action-btn playing--btn"
                        >
                          <Image
                            src="/assets/images/play-button.svg"
                            className=""
                            alt=""
                            height={92}
                            width={92}
                          />
                        </Button>
                      }
                      light={`${CDN_URL}${imageClient2}`}
                      onClick={handlerSetPlayingFive}
                      onPause={pause}
                    />
                    {playingFive ? (
                      <Button
                        className="pauseVbtn player-action-btn"
                        onClick={pause}
                      >
                        <Image
                          src="/assets/images/pause-icon.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        aria-label="play_btn_client1"
                        className="pauseVbtn player-action-btn"
                        onClick={handlerSetPlayingFive}
                      >
                        <Image
                          src="/assets/images/play-button.svg"
                          className=""
                          alt=""
                          height={92}
                          width={92}
                        />
                      </Button>
                    )}
                  </div>
                </div>
              </div> */}
              <div key={6}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;Their ability to start quickly and hit the ground
                        running is outstanding. Internal stakeholders are quite
                        pleased with the value WebClues Infotech delivers.
                        They’ve earned a reputation for on-time deliveries that
                        fulfill initial requirements. Their diverse skills and
                        ability to dive into new projects are also
                        noteworthy.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageMikeLanzone}
                        alt="testimonial-mike"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Mike Lanzone</h3>
                      <p className="proffession mb-0">CEO, Atlanta - USA</p>
                    </div>
                  </div>
                </div>
              </div>
              <div key={7}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;We were very pleased with their ability to turn
                        our idea into a reality. They have got aced designers
                        and developers who can boost customer engagement and
                        bring on board new revenue channels.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageMichaelTerranceHoulder}
                        alt="testimonial-Michael_Terrance"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Michael</h3>
                      <p className="proffession mb-0">CEO, Canada</p>
                    </div>
                  </div>
                </div>
              </div>
              <div key={8}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;The team’s responsive communication, industry
                        knowledge, and receptive approach to the partnership
                        make for a positive and productive collaboration. They
                        always come up with valuable insights.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageStephenBelcher}
                        alt="testimonial-stephen_belcher"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Stephen</h3>
                      <p className="proffession mb-0">
                        Director of IT Solutions, Nashville - USA
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div key={9}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;WebClues Infotech successfully completed the
                        project. Their proactive approach to the project helped
                        them overcome the complex and difficult elements.
                        Despite a slow start, the team worked quickly,
                        communicated consistently, and showed an active interest
                        in the success of the website.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageKiranSingh}
                        alt="testimonial-avtar-kiran"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Kiran Singh</h3>
                      <p className="proffession mb-0">Director, India</p>
                    </div>
                  </div>
                </div>
              </div>
              <div key={10}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;The team was able to take the initial business
                        idea and translate it into requirements, undertake the
                        development, and ensure that it was successfully
                        released. They working in an agile manner, keeping on
                        top of the project scope and communicating effectively
                        throughout.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageTestimonialAvtar}
                        alt="testimonial-avtar"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Pratap</h3>
                      <p className="proffession mb-0">Owner, UK</p>
                    </div>
                  </div>
                </div>
              </div>
              <div key={11}>
                <div className="right_block">
                  <div className="content_block d-flex justify-content-center align-items-center">
                    <div className="text_quote text_para">
                      <p>
                        &quot;The CRM enabled an agile work environment that
                        kept costs to a minimum. The team had a systematic
                        approach to development that kept workloads manageable.
                        Strong communication skills set clear expectations for
                        milestones.&quot;
                      </p>
                    </div>
                  </div>
                  <div className="text_quote text_para d-flex align-items-center mt-2 mt-md-4">
                    <div className="">
                      <Image
                        src={imageShazMehrKhan}
                        alt="testimonial-avtar"
                        width={80}
                        height={80}
                        quality={75}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div className="ms-3">
                      <h3 className="name mb-0">Shaz Khan</h3>
                      <p className="proffession mb-0">
                        Founder &amp; CEO, Australia
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Testimonials
